import { gql } from '@apollo/client'

export const REVIEWERS_OF_BU = gql`
  query ReviewersByBuId($buId: HashedId!) {
    reviewersRelationOfBusinessUnitId(buId: $buId) {
      id
      reviewer {
        id
        firstName
        lastName
        companyName
        buName
        currentLevel
        avatarUrl
      }
      employee {
        id
        firstName
        lastName
        companyName
        buName
        currentLevel
        avatarUrl
      }
      fromDate
      type
      canDelete
    }
  }
`

export const REVIEWERS_OF_COMPANY = gql`
  query ReviewersByCompanyId($companyId: HashedId!) {
    reviewersByCompanyId(companyId: $companyId) {
      id
      reviewer {
        id
        firstName
        lastName
        companyName
        buName
        currentLevel
        avatarUrl
      }
      employee {
        id
        firstName
        lastName
        companyName
        buName
        currentLevel
        avatarUrl
      }
      fromDate
      type
      canDelete
    }
  }
`
export const REVIEWERS_OF_EMPLOYEEE = gql`
  query AllReviewersByEmployeeId($employeeId: HashedId!) {
    allReviewersByEmployeeId(employeeId: $employeeId) {
      id
      firstName
      lastName
      avatarUrl
    }
  }
`
